import { getFeefo } from '@/graphql/queries/util/feefo';

export default async ({ $apolloQuery, $honeybadgerGeneric, store }) => {
  try {
    const feefo = await $apolloQuery(getFeefo);
    store.commit('pageContent/setFeefo', feefo);
  } catch (error) {
    // Handle the error here
    $honeybadgerGeneric.notify(error, {
      name: 'Apollo Mutation Error',
      context: {
        source: 'feefo.js',
        error
      }
    });
  }
};
